export const jenis_surat = {
  router: [
    {
      name: "JENIS SURAT",
      key: "jenis_surat",
      path: "/admin/master/jenis-surat",
      apiUrl: {
        data: "master/api/jenis/surat/",
        preview: "master/api/jenis/surat/",
      },
      breadCrumb: [
        {
          label: "MASTER",
          link: "#",
          active: false,
        },
        {
          label: "JENIS SURAT",
          link: "#",
          active: true,
        },
      ],
      component: "datatable1",
    },
  ],
  model: [
    {
      name: "id",
      isPk: true,
      isForm: false,
      isTable: false,
    },
    {
      name: "nama",
      label: "Nama",
      type: "text",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
  ],
};
